<template>
<div>
    <el-radio-group v-model="device.connection_type">
  <el-radio label="ethernet">Ethernet</el-radio>
  <el-radio label="satcom">Satcom</el-radio>
  <el-radio label="nbiot">NBIoT</el-radio>
  <!-- <el-radio label="lora">Lora</el-radio>
  <el-radio label="gprs">GPRS</el-radio> -->
</el-radio-group>
  <nbiot ref="nbiot_data" v-show="device.connection_type==='nbiot'" @closeDialog="outerVisible = false" />
  <!-- <lora ref="lora_data" v-show="device.connection_type==='lora'" @closeDialog="outerVisible = false" />
  <gprs ref="gprs_data" v-show="device.connection_type==='gprs'" @closeDialog="outerVisible = false" /> -->
  <ethernet ref="ethernet_data" v-show="device.connection_type==='ethernet'" @closeDialog="outerVisible = false" />
  <satcom ref="satcom_data" v-show="device.connection_type==='satcom'" @closeDialog="outerVisible = false" />
  
      <el-button :loading="loading" type="primary" @click="save" :disabled="loading">{{loading?'Saving':'Save'}}
      </el-button>
      <el-button type="warning" @click="$emit('closeDialog')">Cancel</el-button>
  
  
 
</div>
  
</template>

<script>
import { post } from "../../../../../API/cloudFunctions";
import nbiot from "./nbiot";
import lora from "./lora";
import gprs from "./gprs";
import ethernet from "./ethernet";
import satcom from "./satcom";
import { mapGetters } from "vuex";

export default {
  created() {
    if (this.$store.getters.smtpConfig) {
      this.smtp = this.$store.getters.smtpConfig;
    }
  },
  components: {
    nbiot,
    ethernet,
    gprs,
    satcom,
    lora
  },
  name: "configuration",
  data() {
    return {
      testEmail: "",
      profile: {},
      device: {
        connection_type: "ethernet",
        comms: {
          name: "web",
          url:
            "https://us-central1-tisalabs-iot-platform-dev.cloudfunctions.net/"
        }
      },

      loading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  created() {
    this.profile = this.currentUser;
    console.log("currentUser", this.profile);
    if (this.currentUser.comms) {
      this.device.comms = this.currentUser.comms;
    }
  },
  mounted() {},
  methods: {
    setComms() {
      switch (this.device.connection_type) {
        case "ethernet":
          this.device.comms = this.$refs.ethernet_data.comms;
          break;
        case "satcom":
          this.device.comms = this.$refs.satcom_data.comms;
          break;
        case "nbiot":
          this.device.comms = this.$refs.nbiot_data.comms;
          break;
        case "lora":
          this.device.comms = this.$refs.lora_data.comms;
          break;
        case "gprs":
          this.device.comms = this.$refs.gprs_data.comms;
          break;
      }
    },
    save() {
      this.setComms();
      this.profile.comms = this.device.comms;
      this.loading = true;
      post("updateUser", { updates: this.profile })
        .then(success => {
          this.loading = false;

          localStorage.setItem("currentUser", JSON.stringify(this.profile));
          this.$message.success("user details updated.");
          this.$emit("closeDialog");
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$message.error("oops,unable to update user details");
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/configuration/configuration.vue